// extracted by mini-css-extract-plugin
export default {"cookie":"index-module__cookie___eGGcI","link":"index-module__link___qXZ2v","btn":"index-module__btn___GtLAp"};